import { useQuery } from '@tanstack/react-query'

import { STRIPE_TIER } from '#components/Settings/Org/plans'
import { IOrg, useMst } from '#state'

export const seatCapacityQueryKey = (orgId: string) => [
  'workspaceSeatCapacity',
  orgId,
]

// Stripe Seats belong to the account, not to one workspace. This hook answers the two
// questions the members page asks. How many seats does the plan allow? Who
// already holds a seat in another workspace on the account?
export const useSeatCapacity = (
  org: IOrg,
  { enabled = true }: { enabled?: boolean } = {},
) => {
  const { apiClient } = useMst()
  const isStripeTier = org.tier === STRIPE_TIER

  const query = useQuery({
    enabled: enabled && isStripeTier,
    queryKey: seatCapacityQueryKey(org.id),
    queryFn: () => apiClient.workspaceSeatCapacity({ orgId: org.id }),
  })

  return { data: query.data, pending: isStripeTier && query.isPending }
}
